import './loader.scss';

class Loader {
    constructor(element) {
        this.$loader = element;
        this.$loaderOverlay = this.$loader.querySelector('[data-loader="overlay"]');
        this.$$forms = document.querySelectorAll('form');
        this.$$submitButtons = [];
    }

    initialize() {
        if (!this.$loaderOverlay) {
            return;
        }

        this.$$forms.forEach(form => {
            const buttons = form.querySelectorAll('[type="submit"]');
            buttons.forEach(btn => this.$$submitButtons.push(btn));

            form.addEventListener('submit', () => {
                this.showLoaderOverlay();
            });
        });
    }

    showLoaderOverlay() {
        this.$loaderOverlay.classList.add('loader__overlay--is-active');
        this.$$submitButtons.forEach(btn => btn.disabled = true);

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                this.$loaderOverlay.classList.remove('loader__overlay--is-active');
                this.$$submitButtons.forEach(btn => btn.disabled = false);
            }
        });
    }

    hideLoaderOverlay() {
        this.$loaderOverlay.classList.remove('loader__overlay--is-active');
        this.$$submitButtons.forEach(btn => btn.disabled = false);
    }
}

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails?.$context;

    if ($context) {
        const $$loaders = $context.querySelectorAll('[data-loader="root"]');

        if ($$loaders.length > 0) {
            $$loaders.forEach(($loaderElement) => {
                const loader = new Loader($loaderElement);
                loader.initialize();
            });
        }
    }
});
